import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import { Fonts, Names } from 'types/icon';

import styles from './Icon.module.scss';

export type IconProps = {
  font?: Fonts;
  name: Names;
  className?: string;
};

export const Icon = ({ font = 'madrid', name, className }: IconProps) => {
  const ref = useRef<HTMLElement>(null);
  const [isDuotone, setIsDuotone] = useState(false);

  useEffect(() => {
    const { current } = ref;
    if (current !== null) {
      const fontWeight = window
        .getComputedStyle(current)
        .getPropertyValue('font-weight');
      setIsDuotone(fontWeight === '800');
    }
  }, [ref, font]);

  return (
    <i
      ref={ref}
      className={classNames(styles.root, className, {
        [styles[`name-${name}`]]: name,
        [styles[`font-${font}`]]: font,
        [styles.isDuotone]: isDuotone,
      })}
    />
  );
};
